import {
    RaikoBaseDialogContentContainer,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {UsersAvatarService} from "../../serverService/usersAvatarService/UsersAvatarService";
import {css} from "@emotion/css";

export default function AddNewPredefinedAvatar({handleAddNewItem, handleCloseAddNewAvatarDialog}) {

    const [title, setTitle] = useState("");
    const [slug, setSlug] = useState("");
    const [actionButtonLoading, setActionButtonLoading] = useState(false)


    const service = new UsersAvatarService();

    function handleAddNewPredefinedAvatar() {
        setActionButtonLoading(true)
        service.addNewPredefinedAvatar(title, slug)
            .then(response => {
                showSuccessMessage("آواتار جدید با موفقیت افزوده شد.")
                handleAddNewItem(response)
                handleCloseAddNewAvatarDialog()
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setActionButtonLoading(false)
        })
    }


    return (
        <RaikoBaseDialogContentContainer>
            <RaikoSectionContainer
                title={"افزودن آواتار جدید"}
                hasActionButton
                actionButtonTitle={"افزودن"}
                actionButtonOnclickWithValidation={handleAddNewPredefinedAvatar}
                actionButtonLoadingState={actionButtonLoading}
            >
                <RaikoSimpleInputOutlined
                    labelText={"عنوان آواتار"}
                    value={title}
                    setValue={setTitle}
                    required
                />
                <RaikoSimpleInputOutlined
                    labelText={"slug"}
                    value={slug}
                    setValue={setSlug}
                    required
                />
            </RaikoSectionContainer>
        </RaikoBaseDialogContentContainer>
    )
}